import React, { useEffect, useState } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import truncate from "truncate-html"
import { Search } from "@organic-return/foundation-react/src/components/Search/Search"
import { Choose, Text } from "@organic-return/foundation-react/src/components/Search/Filter"
import { ISearchContext } from "@organic-return/foundation-react/src/components/Search/SearchContext"
import { parseISO, format, startOfMonth, endOfMonth, isWithinInterval } from "date-fns"
import { EWsrvTransform } from "@organic-return/foundation-react/src/lib/Media/util"
import { WsrvImage } from "@organic-return/foundation-react/src/components/Media/WsrvImage"

const PostListing = (props: any) => {
  // graphql query for posts data
  const data = useStaticQuery(graphql`
    query {
      posts: allDrupalNodePost(sort:{date: DESC}) {
        nodes {
          title
          content
          date
          image {
            url
            height
            width
          }
          category {
            title
          }
          tags {
            title
          }
          path
          featuredPost
        }
      }
    }
  `)

  // get posts
  const posts = data.posts.nodes

  //Fixes key issue
  const indexPosts = posts.map((post: any, index: number) => {
    return {
      index,
      post,
    }
  })

  let postsCategories: String[] = []
  posts && posts.length > 0 && (
    posts.forEach((post: any) => {
      if (post.category?.title &&
        !postsCategories.includes(post.category.title)) {
        postsCategories.push(post.category.title)
      }
    })
  )

  const postDatesOptions: any[] = []
  posts && posts.length > 0 && (
    posts.forEach((post: any) => {
      if (post?.date) {

        const monthStartDate = startOfMonth(parseISO(post.date))

        const dateLabel = format(monthStartDate, "MMMM yyyy")
        const dateValue = format(monthStartDate, "yyyy-MM-dd")

        if (!postDatesOptions.some(item => item.value == dateValue)) {

          postDatesOptions.push({
            value: dateValue,
            label: dateLabel
          })
        }
      }
    })
  )

  let postsTagsOptions: any[] = []
  posts && posts.length > 0 && (
    posts.forEach((post: any) => {
      post?.tags?.forEach((tag: any) => {
        if (tag?.title &&
          !postsTagsOptions.some(item => item.value == tag.title)) {
          postsTagsOptions.push({
            value: tag.title,
            label: tag.title
          })
        }
      })
    })
  )

  let featuredPosts = posts?.filter((post: any) => { return post.featuredPost })
    .map((post: any, index: number) => {
      return (
        <Link to={post.path} className="w-full flex flex-row mb-11 gap-x-4 text-body-text" key={index}>
          <WsrvImage
            urlParams={{
              originURL: post.image.url,
              width: post.image.width,
              preset: EWsrvTransform.cover4x3
            }}
            imgProps={{
              className: "w-full",
              wrapperClassName: "w-1/2 pr-4"
            }}
          />
          <div className="flex flex-col gap-3 w-1/2">
            <span className="font-bold leading-5 tracking-wider">{post.title}</span>
            <span className="leading-6 tracking-wider">{format(parseISO(post.date), "dd.MM.yyyy")}</span>
          </div>
        </Link>
      )
    })

  featuredPosts && featuredPosts.length > 0 && (featuredPosts = (
    <div className="flex flex-col w-full gap">
      <div className="flex flex-row gap-x-4 uppercase leading-7 border-b border-accent pb-1 mb-8">
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2_2591)">
            <path d="M4.65724 24.1313C4.53049 24.8528 5.24224 25.4167 5.86949 25.0949L13.0032 21.4289L20.1354 25.0949C20.7626 25.4167 21.4744 24.8528 21.3476 24.1329L19.9989 16.4467L25.7221 10.9932C26.2584 10.4829 25.9821 9.55015 25.2639 9.4494L17.3046 8.3184L13.7556 1.28703C13.688 1.1445 13.5813 1.02408 13.448 0.939753C13.3147 0.85543 13.1602 0.810669 13.0024 0.810669C12.8447 0.810669 12.6902 0.85543 12.5568 0.939753C12.4235 1.02408 12.3169 1.1445 12.2492 1.28703L8.70024 8.32003L0.740994 9.45103C0.0243688 9.55178 -0.253506 10.4845 0.281119 10.9948L6.00599 16.4483L4.65724 24.1345V24.1313ZM12.6279 19.6349L6.63812 22.7127L7.76587 16.2825C7.79229 16.1345 7.78195 15.9823 7.73577 15.8392C7.68958 15.6961 7.60896 15.5665 7.50099 15.4619L2.77874 10.9607L9.36324 10.0247C9.49959 10.0041 9.62891 9.95073 9.74013 9.86922C9.85136 9.78772 9.94117 9.68046 10.0019 9.55665L13 3.6124L16.0014 9.55665C16.0621 9.68046 16.1519 9.78772 16.2631 9.86922C16.3743 9.95073 16.5036 10.0041 16.64 10.0247L23.2245 10.959L18.5022 15.4603C18.394 15.5651 18.3133 15.6949 18.2671 15.8383C18.2209 15.9817 18.2107 16.1343 18.2374 16.2825L19.3651 22.7127L13.3754 19.6349C13.2595 19.5752 13.1311 19.544 13.0008 19.544C12.8705 19.544 12.7421 19.5752 12.6262 19.6349H12.6279Z" fill="black" />
          </g>
          <defs>
            <clipPath id="clip0_2_2591">
              <rect width="26" height="26" fill="white" />
            </clipPath>
          </defs>
        </svg>
        Featured Articles
      </div>
      {featuredPosts}
    </div>
  ))

  const primaryFilters = function (context: ISearchContext) {

    const categories = postsCategories.length > 0 && (
      <div className="flex flex-col w-full">
        <div className="flex flex-row gap-x-4 uppercase leading-7 border-b border-accent pb-1 mb-8">
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2_2586)">
              <path d="M13.4041 18.5854L13 18.4068L12.5959 18.5854L6.18707 21.417L13 4.80248L19.8129 21.417L13.4041 18.5854Z" stroke="black" stroke-width="2" />
            </g>
            <defs>
              <clipPath id="clip0_2_2586">
                <rect width="26" height="26" fill="white" />
              </clipPath>
            </defs>
          </svg>
          Blog Navigation
        </div>
        <a className="font-bold text-body-text uppercase leading-7 mb-1 cursor-pointer" onClick={() => { context.setFilterValue!("category", "") }}>
          All Categories
        </a>
        {postsCategories.map((category: any, index: number) => {
          return (
            <a key={index} className="font-bold text-body-text uppercase leading-7 mb-1 cursor-pointer" onClick={() => { context.setFilterValue!("category", category) }}>
              {category}
            </a>
          )
        })}
      </div>
    )

    const tags = postsTagsOptions.length > 0 && (
      <div className="text-xs w-full flex flex-row flex-wrap bg-body-bg gap-4 font-bold uppercase">
        {postsTagsOptions.map((tag, index) => {
          return (
            <a key={index} className="text-inherit py-2 px-7 bg-neutral-100 border border-neutral-400 cursor-pointer" onClick={() => { context.setFilterValue!("tags", tag.value) }}>
              {tag.label}
            </a>
          )
        })}
      </div>
    )

    const postsDates = postDatesOptions.length > 0 && (
      <div className="flex flex-col w-full">
        <div className="flex flex-row gap-x-4 uppercase leading-7 border-b border-accent pb-1 mb-8">
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2.625C0 2.2769 0.138281 1.94306 0.384422 1.69692C0.630564 1.45078 0.964403 1.3125 1.3125 1.3125H19.6875C20.0356 1.3125 20.3694 1.45078 20.6156 1.69692C20.8617 1.94306 21 2.2769 21 2.625V5.25C21 5.5981 20.8617 5.93194 20.6156 6.17808C20.3694 6.42422 20.0356 6.5625 19.6875 6.5625V16.4062C19.6875 17.2765 19.3418 18.1111 18.7264 18.7264C18.1111 19.3418 17.2765 19.6875 16.4062 19.6875H4.59375C3.72351 19.6875 2.88891 19.3418 2.27356 18.7264C1.6582 18.1111 1.3125 17.2765 1.3125 16.4062V6.5625C0.964403 6.5625 0.630564 6.42422 0.384422 6.17808C0.138281 5.93194 0 5.5981 0 5.25V2.625ZM2.625 6.5625V16.4062C2.625 16.9284 2.83242 17.4292 3.20163 17.7984C3.57085 18.1676 4.07161 18.375 4.59375 18.375H16.4062C16.9284 18.375 17.4292 18.1676 17.7984 17.7984C18.1676 17.4292 18.375 16.9284 18.375 16.4062V6.5625H2.625ZM19.6875 2.625H1.3125V5.25H19.6875V2.625ZM6.5625 9.84375C6.5625 9.6697 6.63164 9.50278 6.75471 9.37971C6.87778 9.25664 7.0447 9.1875 7.21875 9.1875H13.7812C13.9553 9.1875 14.1222 9.25664 14.2453 9.37971C14.3684 9.50278 14.4375 9.6697 14.4375 9.84375C14.4375 10.0178 14.3684 10.1847 14.2453 10.3078C14.1222 10.4309 13.9553 10.5 13.7812 10.5H7.21875C7.0447 10.5 6.87778 10.4309 6.75471 10.3078C6.63164 10.1847 6.5625 10.0178 6.5625 9.84375Z" fill="black" />
          </svg>
          Archives
        </div>
        {postDatesOptions.map((postDate, index) => {
          return (
            <a key={index} className="font-bold text-body-text uppercase leading-7 mb-1 cursor-pointer" onClick={() => { context.setFilterValue!("postDate", postDate.value) }}>
              {postDate.label}
            </a>
          )
        })}
      </div>
    )

    return (
      <>
        <Text
          context={context}
          className="border-accent border-b [&_label]:flex [&_label]:items-center"
          inputClassName="text-sm rounded-none bg-transparent pl-0 border-none w-full"
          label="Blog search"
          placeholder="Blog search"
          param="keyword"
          resolver={(arg: any, text) => {
            let argl = arg.post;
            let match = text.toLowerCase();
            return (argl.title && argl.title.toLowerCase().includes(match)) ||
              (argl.content.text &&
                argl.content.text.toLowerCase().includes(match))
              ? true
              : false;
          }}
        />
        <Choose
          className="hidden"
          context={context}
          placeholder="Category"
          label="Category"
          param="category"
          resolver={arg => arg.post.category?.title}
          match="one"
        />
        <Choose
          className="hidden"
          context={context}
          placeholder="Post Date"
          label="Post Date"
          param="postDate"
          resolver={arg => arg.post.date}
          options={postDatesOptions}
          customFilter={(arg: any, value) => {
            const vstr = value as string
            const monthStartDate = parseISO(vstr)
            const monthEndDate = endOfMonth(monthStartDate)
            const postDate = parseISO(arg.post.date)
            return isWithinInterval(postDate, { start: monthStartDate, end: monthEndDate })
          }}
          match="one"
        />
        <Choose
          className="hidden"
          context={context}
          placeholder="Tags"
          label="Tags"
          param="tags"
          resolver={() => { return "tags" }}
          options={postsTagsOptions}
          customFilter={(arg: any, value) => {
            const vstr = value as string
            return arg.post.tags?.some((tag: any) => tag.title == vstr) ?? false
          }}
          match="one"
        />
        {categories}
        {postsDates}
        {featuredPosts}
        {tags}
      </>
    )
  }

  const [isMounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, [])

  if (!isMounted) return null

  // if there are no posts, display message on frontend
  if (posts.length <= 0) {
    return (
      <div className="mt-44 px-6 flex flex-col items-center justify-center">
        <h1 className="text-3xl text-center font-bold">No posts available.</h1>
        <div className="my-10">
          <Link
            to="/"
            className="px-4 py-3 my-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-primary-600 hover:bg-primary-500 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary transition duration-300"
          >
            Return Home
          </Link>
        </div>
      </div>
    )
  }

  return (
    <Search
      index={indexPosts}
      pageSize={4}
      pagerBottom={true}
      showCount={false}
      className="max-w-screen-xl w-full mx-auto px-4 blog-search !flex !flex-wrap justify-center"
      resultsClassName="sm:block columns-1 md:gap-10 lg:w-[60%] order-1 lg:order-1"
      pagerClassName="order-2 lg:order-3"
      primaryFilters={primaryFilters}
      filterClassName="lg:w-[40%] order-3 lg:order-2 [&_.search-filters-primary]:!flex [&_.search-filters-primary]:!flex-col [&_.search-filters-primary]:!max-w-full lg:pl-24 xl:pl-32"

      renderItem={(item, index) => {
        const post = item.post
        // truncate post content
        const description = truncate(post?.content, {
          length: 212,
          decodeEntities: true,
          stripTags: true,
          reserveLastWord: true,
        })

        return (
          <div
            key={item.index}
            className={`block w-full`}
          >
            <Link to={post?.path} className="relative">
              <WsrvImage
                urlParams={{
                  originURL: post.image.url,
                  width: post.image.width,
                  preset: EWsrvTransform.cover4x3
                }}
                imgProps={{
                  className: "w-full",
                  wrapperClassName: "w-full"
                }}
              />
            </Link>
            <div className="px-0 py-8">
              <Link to={post?.path}>
                <h3 className="uppercase font-bold tracking-widest text-2xl leading-10">
                  {post.title}
                </h3>
              </Link>
              <p className="text-body-text font-light">
                {description}
              </p>
              <div className="flex flex-row justify-start font-medium text-sm mt-4">
                <span>{format(parseISO(post.date), "dd.MM.yyyy")}</span>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

export default PostListing

export const query = graphql`
fragment DrupalPostsListingContent on DrupalPostsListing {
  id
}
`